var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:filter"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.9992 12V19.88C14.0392 20.18 13.9392 20.5 13.7092 20.71C13.6166 20.8027 13.5068 20.8763 13.3858 20.9264C13.2648 20.9766 13.1351 21.0024 13.0042 21.0024C12.8732 21.0024 12.7435 20.9766 12.6225 20.9264C12.5016 20.8763 12.3917 20.8027 12.2992 20.71L10.2892 18.7C10.1801 18.5934 10.0972 18.463 10.0469 18.319C9.99654 18.175 9.98022 18.0213 9.99915 17.87V12H9.96915L4.20915 4.62C4.04676 4.41153 3.97349 4.14726 4.00534 3.88493C4.0372 3.6226 4.17159 3.38355 4.37915 3.22C4.56915 3.08 4.77915 3 4.99915 3H18.9992C19.2192 3 19.4292 3.08 19.6192 3.22C19.8267 3.38355 19.9611 3.6226 19.993 3.88493C20.0248 4.14726 19.9515 4.41153 19.7892 4.62L14.0292 12H13.9992Z",
    fill: "#8E9EA4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.51e6ddca37b5dea52b446a422b828028.svg";
export { ForwardRef as ReactComponent };